var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ax-avatar-stack",class:_vm.classes},[_vm._t("default",function(){return _vm._l((_vm.items),function(item){return _c('AxUserAvatar',_vm._b({key:item.user.userId},'AxUserAvatar',_vm.avatarProps(item),false))})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }